// bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import * as $ from "jquery";
import BaoDialogViewModel from "./../factories/bao-dialog";
// bao migrate - module not found: import loginModule from "modules/login-module";
function LoginViewModel(Model) {
    var self = this;
    self.IsLoading = ko.observable();
    self.LanguageSymbol = ko.observable();
    self.Password = ko.observable();
    self.CaptionUsername = ko.observable();
    self.CaptionPassword = ko.observable();
    self.CaptionLanguage = ko.observable();
    self.CaptionLogin = ko.observable();
    self.CaptionAutoLogin = ko.observable();
    self.CaptionRequestPassword = ko.observable();
    self.CaptionEnableRegisterUser = ko.observable();
    self.CaptionADAuth = ko.observable();
    self.CaptionOk = ko.observable();
    self.MandatorActive = ko.observable(false);
    self.ADAuth = ko.observable(true);
    self.ADAuthEnabled = ko.observable(false);
    self.ADAuthActive = ko.computed(function () {
        return self.ADAuth() == true && self.ADAuthEnabled() == true;
    });
    self.ADAuthActive.subscribe(function (newValue) {
        self.Username("");
        if (newValue == true) {
            self.GetADName();
            self.Password("");
        }
    });
    self.Password.subscribe(function (newValue) {
        if (self.ADAuthActive() == true && newValue != "") {
            self.Password("");
        }
    });
    self.GetADName = function () {
        Bao.post("Login/GetADName", function (value) {
            self.Username(value);
        });
    };
    self.Dialog = new BaoDialogViewModel();
    self.Dialog.Buttons([new BaoDialogViewModel.ButtonFactory(self.Dialog, self.CaptionOk)]);
    self.Dialog.Width("400px");
    self.Dialog.VerticalMode("middle");
    self.UserFocus = function () { };
    self.Login = function () {
        if (self.ADAuthActive()) {
            self.SingleSignOn(true);
        }
        else {
            self.IsLoading(true);
            const mandatorid = self.getParam("mandatorid");
            if (mandatorid) {
                self.MandatorId = mandatorid;
            }
            Bao.post("Login/Login", JSON.stringify({
                loginModel: ko.map.toJS(self)
            }), function (value) {
                if (value.Result == true) {
                    self.SelectClient(value.Redirect);
                }
                else {
                    self.IsLoading(false);
                    if (value.Id == "UserMustChangePassword") {
                        self.ChangePassword(value.Redirect);
                    }
                    else {
                        self.Password("");
                        self.Dialog.Template(value.Message);
                        self.Dialog.Open();
                        self.Dialog.Closed = function () {
                            self.UserFocus();
                        };
                    }
                }
            });
        }
    };
    self.ChangePassword = function (redirect) {
        if (typeof self.LanguageSymbol() === "undefined") {
            self.LanguageSymbol(Bao.Session.Language.Symbol());
        }
        var captionOK = Bao.Session.GetMessage("msgOk");
        var captionCancel = Bao.Session.GetMessage("msgCancel");
        var changePasswordFn = function () {
            if (self.ChangePasswordDialog.ViewModel().CompleteCheck()) {
                Bao.post("Login/ChangePassword", JSON.stringify({
                    changePasswordModel: ko.map.toJS(self.ChangePasswordDialog.ViewModel())
                }), function (value) {
                    self.IsLoading(false);
                    if (value.Result == true) {
                        self.ChangePasswordDialog.Close();
                        if (redirect != null) {
                            self.Dialog.Template(value.Message);
                            self.Dialog.Open();
                            self.Dialog.Closed = function () {
                                self.SelectClient(redirect);
                            };
                        }
                    }
                    else {
                        self.Dialog.Template(value.Message);
                        self.Dialog.Open();
                        self.UserFocus();
                    }
                });
            }
        };
        Bao.post("Login/ChangePasswordDialog", function (value) {
            window.baorequire(["ViewModels/BaoDialog/ChangePasswordDialog"], function (ChangePasswordModel) {
                self.ChangePasswordDialog = new BaoDialogViewModel();
                self.ChangePasswordDialog.Buttons([{
                        Title: captionOK,
                        Click: changePasswordFn,
                        Enabled: ko.observable(true)
                    }, {
                        Title: captionCancel,
                        Click: function () {
                            self.ChangePasswordDialog.Close();
                        },
                        Enabled: ko.observable(true)
                    }]);
                self.ChangePasswordDialog.Template(value.Message);
                self.ChangePasswordDialog.ViewModel(new ChangePasswordModel(value.Model));
                self.ChangePasswordDialog.Width(700);
                self.ChangePasswordDialog.Open();
            });
        });
    };
    self.SelectClient = function (redirect, useHash) {
        if (useHash == null) {
            useHash = true;
        }
        var captionOK = Bao.Session.GetMessage("msgOk");
        var captionCancel = Bao.Session.GetMessage("msgCancel");
        if (self.MandatorActive()) {
            window.baorequire(["ViewModels/SelectClient"], function (SelectClientModel) {
                Bao.post("Login/GetSelectClient", function (value) {
                    var mySelectClientModel;
                    if (value.ClientId != null) {
                        mySelectClientModel = new SelectClientModel({});
                        mySelectClientModel.Redirect = redirect;
                        mySelectClientModel.LoginModel = self;
                        mySelectClientModel.ClientId(value.ClientId);
                        mySelectClientModel.UseHash = useHash;
                        mySelectClientModel.SelectClient();
                    }
                    else {
                        mySelectClientModel = new SelectClientModel(value.Model);
                        mySelectClientModel.UseHash = useHash;
                        mySelectClientModel.ClientId.subscribe(function (newid) {
                            if (newid != null) {
                                self.SelectClientDialog.Buttons()[0].Enabled(true);
                            }
                        });
                        self.SelectClientDialog = new BaoDialogViewModel();
                        self.SelectClientDialog.Title();
                        self.SelectClientDialog.VerticalMode("middle");
                        self.SelectClientDialog.Template(value.Message);
                        self.SelectClientDialog.Buttons([{
                                Title: captionOK,
                                Click: mySelectClientModel.SelectClient,
                                Enabled: ko.observable(false)
                            }, {
                                Title: captionCancel,
                                Click: function () {
                                    mySelectClientModel.Active(false);
                                    self.SelectClientDialog.Close();
                                    self.IsLoading(false);
                                    self.UserFocus();
                                },
                                Enabled: ko.observable(true)
                            }]);
                        self.SelectClientDialog.ViewModel(mySelectClientModel);
                        self.SelectClientDialog.Width(400);
                        mySelectClientModel.SelectClientDialog = self.SelectClientDialog;
                        mySelectClientModel.Redirect = redirect;
                        mySelectClientModel.LoginModel = self;
                        self.SelectClientDialog.Open();
                        self.IsLoading(false);
                    }
                });
            });
        }
        else {
            var url;
            if (useHash) {
                url = redirect + window.location.hash;
            }
            else {
                url = redirect;
            }
            window.location = url;
        }
    };
    self.RequestResetPassword = function () {
        window.baorequire(["ViewModels/BaoDialog/RequestResetPassword"], function (RequestResetPassword) {
            new RequestResetPassword(self.LanguageSymbol(), self.Username());
        });
    };
    var captionDeferred;
    self.LanguageSymbol.subscribe(function (newval) {
        if (captionDeferred != null && captionDeferred.abort != undefined) {
            captionDeferred.abort();
        }
        captionDeferred = Bao.Session.GetCaptions("Login", newval).then(function (captions) {
            self.CaptionUsername(captions.lblUsername);
            self.CaptionPassword(captions.lblPassword);
            self.CaptionLanguage(captions.lblLanguage);
            self.CaptionAutoLogin(captions.lblAutoLogin);
            self.CaptionRequestPassword(captions.lblRequestPassword);
            self.CaptionEnableRegisterUser(captions.lblRegisterUser);
            self.CaptionLogin(captions.btnLogin);
            self.CaptionADAuth(captions.lblADAuth);
            self.CaptionOk(captions.btnOk);
        });
    });
    self.FormVisible = ko.observable(true);
    self.SingleSignOn = function (force) {
        var def = $.Deferred();
        if (force == true || self.getParam("mode") != "logout") {
            self.IsLoading(true);
            var languageSymbol = "";
            if (force == true) {
                languageSymbol = self.LanguageSymbol();
            }
            return Bao.post("Login/SingleSignOn", JSON.stringify({
                languageSymbol: languageSymbol
            })).then(function (result) {
                if (result === true) {
                    self.SelectClient(window.absolutePath);
                }
            }).always(function () {
                self.IsLoading(false);
                def.resolve();
            });
        }
        else {
            def.resolve();
        }
        return def.promise();
    };
    self.getParam = function (variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) {
                return pair[1];
            }
        }
        return false;
    };
    self.init = function () {
        return Bao.post("Login/GetLoginModel").then(function (result) {
            ko.map.fromJS(result, self);
        });
    };
    self.loaded = function () {
        self.SingleSignOn();
    };
    return self;
}
export default LoginViewModel;